module.exports = __webpack_public_path__ + "static/media/watchmore.1742abc3.png";